<div class="container-fluid">
  <h4 id="upper">Commande Market-place</h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <!-- Barre de filtres -->
          <div class="row mb-3">
            <div class="col-md-12">
              <div class="d-flex align-items-center gap-3 flex-wrap">
                <!-- Recherche -->
                <div class="flex-grow-1" style="min-width: 200px;">
                  <label class="form-label mb-0">Rechercher</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="mdi mdi-magnify"></i></span>
                    <input title="Rechercher par référence, acheteur, téléphone ou montant" type="text"
                      [(ngModel)]="searchTerm" (input)="filterBySearchTerm()" class="form-control" id="searchMembre"
                      placeholder="Rechercher..." />
                    <button class="btn btn-outline-secondary" (click)="searchTerm = ''; filterBySearchTerm()"
                      type="button" *ngIf="searchTerm">
                      <i class="mdi mdi-close"></i>
                    </button>
                  </div>
                </div>

                <!-- Filtre par statut de paiement -->
                <div style="min-width: 200px;">
                  <label class="form-label mb-0">Statut paiement</label>
                  <select class="form-select" [(ngModel)]="selectedStatus" (change)="onStatusChange()">
                    <option *ngFor="let option of statusOptions" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>

                <!-- Filtre par statut de commande -->
                <div style="min-width: 200px;">
                  <label class="form-label mb-0">Statut commande</label>
                  <select class="form-select" [(ngModel)]="selectedOrderStatus" (change)="onOrderStatusChange()">
                    <option *ngFor="let option of orderStatusOptions" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>

                <!-- Filtre par date -->
                <div style="min-width: 200px;">
                  <label class="form-label mb-0">Date début</label>
                  <input type="date" class="form-control" [(ngModel)]="dateDebut" (change)="applyFilters()" />
                </div>
                <div style="min-width: 200px;">
                  <label class="form-label mb-0">Date fin</label>
                  <input type="date" class="form-control" [(ngModel)]="dateFin" (change)="applyFilters()" />
                </div>

                <!-- Statistiques rapides -->
                <div class="d-flex gap-2 flex-wrap" style="margin-top: 22px;">
                  <span class="badge bg-secondary p-2">
                    <i class="mdi mdi-cart"></i>
                    Total: {{ items.length }}
                  </span>
                  <span class="badge bg-success p-2">
                    <i class="mdi mdi-check-circle"></i>
                    Payés: {{ getStatusCount('paid') }}
                  </span>
                  <span class="badge bg-danger p-2">
                    <i class="mdi mdi-close-circle"></i>
                    Échoués: {{ getStatusCount('failed') }}
                  </span>
                  <span class="badge bg-warning p-2">
                    <i class="mdi mdi-clock"></i>
                    En attente: {{ getStatusCount('pending') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tableau -->
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                  style="border-color: #578D63;">
                  <th scope="col">Référence</th>
                  <th scope="col">Acheteur</th>
                  <th scope="col">Téléphone</th>
                  <th scope="col">Montant</th>
                  <th scope="col">Paiement</th>
                  <th scope="col">Commande</th>
                  <th scope="col">Date</th>
                  <th scope="col" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr *ngFor="let item of paginatedItems">
                  <td>
                    <span class="table-link1 text-truncate d-block" title="{{ item?.ref_marchand }}">
                      {{ item?.ref_marchand }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block">
                      {{ item?.acheteur?.prenom }} {{ item?.acheteur?.nom }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block">
                      {{ item?.acheteur?.telephone || '-' }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block fw-bold">
                      {{ item?.montant_total }} FCFA
                    </span>
                  </td>
                  <td>
                    <span class="badge {{ getStatusBadge(item?.status) }}" style="font-size: 12px; padding: 6px 12px;">
                      <i class="mdi" [class.mdi-check-circle]="item?.status === 'paid'"
                        [class.mdi-close-circle]="item?.status === 'failed'"
                        [class.mdi-clock]="item?.status === 'pending'" [class.mdi-sync]="item?.status === 'processing'"
                        me-1>
                      </i>
                      {{ getStatusLabel(item?.status) }}
                    </span>
                  </td>
                  <td>
                    <span class="badge {{ getOrderStatusBadge(item?.order_status) }}" style="font-size: 12px; padding: 6px 12px;">
                      <i class="mdi" [class.mdi-check]="item?.order_status === 'traite'"
                        [class.mdi-clock]="item?.order_status === 'en_attente'"
                        [class.mdi-sync]="item?.order_status === 'en_cours'"
                        [class.mdi-close]="item?.order_status === 'annule'"
                        me-1>
                      </i>
                      {{ getOrderStatusLabel(item?.order_status) }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block" style="font-size: 12px;">
                      {{ formatDate(item?.created_at) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <a (click)="openDetailModal(item)" style="cursor: pointer;" class="me-2 text-info" v-b-tooltip.hover
                      title="Voir les détails">
                      <i class="mdi mdi-eye font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Message si aucun résultat -->
          <div *ngIf="paginatedItems.length === 0 && !isLoading" class="text-center py-4">
            <i class="mdi mdi-inbox-outline" style="font-size: 48px; color: #ccc;"></i>
            <h5 class="text-muted">Aucune commande trouvée</h5>
            <p class="text-muted" *ngIf="selectedStatus || selectedOrderStatus || searchTerm">
              Aucun résultat ne correspond à vos critères de recherche.
              <a (click)="resetFilters()" style="cursor: pointer; color: #578D63;">
                Réinitialiser les filtres
              </a>
            </p>
          </div>

          <!-- Chargement -->
          <div class="d-flex justify-content-center" *ngIf="isLoading === true">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Chargement en cours...</h5>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Détails (adapté pour les commandes) -->
<ng-template #detailModal let-modal>
  <div class="modal-header" style="background-color: #578D63; color: white;">
    <h5 class="modal-title text-white">
      <i class="mdi mdi-receipt-text me-2"></i>
      Détails de la commande
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body" *ngIf="selectedItem">
    <!-- En-tête de la commande -->
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-subtitle mb-2 text-muted">Informations générales</h6>
            <p class="mb-1"><strong>Référence :</strong> {{ selectedItem.reference }}</p>
            <p class="mb-1"><strong>Réf. Marchand :</strong> {{ selectedItem.ref_marchand }}</p>
            <p class="mb-1"><strong>Montant total :</strong> <span class="fw-bold text-success">{{ selectedItem.montant_total }} FCFA</span></p>
            <p class="mb-1">
              <strong>Statut paiement :</strong>
              <span class="badge {{ getStatusBadge(selectedItem.status) }}">
                {{ getStatusLabel(selectedItem.status) }}
              </span>
            </p>
            <p class="mb-1">
              <strong>Statut commande :</strong>
              <span class="badge {{ getOrderStatusBadge(selectedItem.order_status) }}">
                {{ getOrderStatusLabel(selectedItem.order_status) }}
              </span>
            </p>
            <p class="mb-0"><strong>Date de création :</strong> {{ formatDate(selectedItem.created_at) }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-subtitle mb-2 text-muted">Informations acheteur</h6>
            <p class="mb-1"><strong>Nom :</strong> {{ selectedItem.acheteur?.prenom }} {{ selectedItem.acheteur?.nom }}</p>
            <p class="mb-1"><strong>Téléphone :</strong> {{ selectedItem.acheteur?.telephone }}</p>
            <p class="mb-0"><strong>Référence :</strong> {{ selectedItem.acheteur?.reference }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Détails du paiement et livraison -->
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header bg-info text-white">
            <h6 class="mb-0">Détails du paiement</h6>
          </div>
          <div class="card-body">
            <p class="mb-1">
              <strong>Mode de paiement :</strong>
              <i class="{{ getPaymentMethodIcon(selectedItem.payment_method) }} me-1"></i>
              {{ getPaymentMethodLabel(selectedItem.payment_method) }}
            </p>
            <p class="mb-1"><strong>Transaction ID :</strong> {{ selectedItem.transaction_id || 'Non disponible' }}</p>
            <p class="mb-0"><strong>Description :</strong> {{ selectedItem.description || 'Non spécifié' }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header bg-primary text-white">
            <h6 class="mb-0">Informations livraison</h6>
          </div>
          <div class="card-body">
            <p class="mb-1"><strong>Adresse :</strong> {{ selectedItem.livraison?.adresse || 'Non spécifiée' }}</p>
            <p class="mb-1"><strong>Téléphone :</strong> {{ selectedItem.livraison?.telephone || 'Non spécifié' }}</p>
            <p class="mb-0"><strong>Ville ID :</strong> {{ selectedItem.livraison?.ville_id || 'Non spécifié' }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Articles de la commande -->
    <div class="card" *ngIf="selectedItem.articles && selectedItem.articles.length > 0">
      <div class="card-header bg-success text-white">
        <h6 class="mb-0">Articles de la commande</h6>
      </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-striped mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Produit</th>
                <th>Quantité</th>
                <th>Prix unitaire</th>
                <th class="text-end">Sous-total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of selectedItem.articles; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.produit || 'Non spécifié' }}</td>
                <td>{{ item.quantite }}</td>
                <td>{{ item.prix_vente }} FCFA</td>
                <td class="text-end">{{ item.sous_total }} FCFA</td>
              </tr>
              <tr class="table-active">
                <td colspan="4" class="text-end fw-bold">Total :</td>
                <td class="text-end fw-bold">{{ getTotalItemsMontant(selectedItem.articles) }} FCFA</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">
      <i class="mdi mdi-close me-1"></i> Fermer
    </button>
    <button type="button" class="btn btn-primary" (click)="modal.close('Close click')">
      <i class="mdi mdi-check me-1"></i> OK
    </button>
  </div>
</ng-template>

<p-toast />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>